import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './TreatmentCard.scss';
import { LanguageContext } from '../../context/LanguageContext';
import useAnalytics from '../../hooks/useAnalytics';

const TreatmentCard = ({ treatment }) => {
    const { currentLang } = useContext(LanguageContext);
    const { trackEvent } = useAnalytics();

    const handleCardClick = () => {
        trackEvent('treatment_card_click', {
            treatment_id: treatment.slug,
            treatment_title: treatment.title,
            category: treatment.category,
            source: 'treatment_grid'
        });
    };

    const treatmentUrl = currentLang === 'tr' 
        ? `/tedavi/${treatment.slug}` 
        : `/en/treatment/${treatment.slug}`;

    console.log('TreatmentCard - treatment prop:', treatment); // Debug için
    const cardImage = treatment.image?.replace('asset.cloudinary.com', 'res.cloudinary.com');
    console.log('TreatmentCard - cardImage:', cardImage); // Debug için

    // Placeholder image if no image provided
    const placeholderImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjIyMCIgdmlld0JveD0iMCAwIDQwMCAyMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMjIwIiBmaWxsPSIjZjhmOWZlIi8+CjxwYXRoIGQ9Ik0xNzUgODBIMjI1VjEzMEgxNzVWODBaIiBmaWxsPSIjMjMyYTZjIiBmaWxsLW9wYWNpdHk9IjAuMyIvPgo8cGF0aCBkPSJNMTg1IDEwMEwyMDUgMTIwTDIxNSAxMTBMMjI1IDEyMFYxMzBIMTc1VjEyMEwxODUgMTAwWiIgZmlsbD0iIzIzMmE2YyIgZmlsbC1vcGFjaXR5PSIwLjUiLz4KPHN2Zz4K';

    return (
        <div className="treatment-card" onClick={handleCardClick}>
            <Link to={treatmentUrl} className="treatment-card-link">
                <div className="treatment-card-image">
                    <img 
                        src={cardImage || placeholderImage} 
                        alt={treatment.title}
                        onError={(e) => {
                            // Prevent infinite loop by setting a data URL
                            if (!e.target.src.startsWith('data:')) {
                                e.target.src = placeholderImage;
                            }
                        }}
                    />
                    <div className="treatment-card-category">
                        {treatment.category}
                    </div>
                </div>
                <div className="treatment-card-content">
                    <h3 className="treatment-card-title">
                        {treatment.title}
                    </h3>
                    <p className="treatment-card-description">
                        {treatment.shortDesc}
                    </p>
                </div>
            </Link>
        </div>
    );
};

export default TreatmentCard; 